import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Row,
  Col,
  Empty,
  Button,
  Modal,
  Spin,
  Tooltip,
  Input,
  message,
} from "antd";
import Heading from "../../../components/Heading";
import { getHubList } from "../../../actionsMethods/masterMethods";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { getPremiseId } from "../../../utils/worker";
import { ReactComponent as Scan_check } from "../../../assests/images/SVG/check.svg";
import API from "../../../api";
import urls from "../../../api/urls";
const { SORT_SHIPMENT, CHANGE_SORT_SHIPMENT_STATUS } = urls;
import "./style.scss";
const ViewSortingMM = () => {
  const premiseId = getPremiseId();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [sortShipment, setSortShipment] = useState([]);
  const [modalContent, setModalContent] = useState({});
  const [premiseName, setPremiseName] = useState("");
  const [loading, setLoading] = useState(false);
  const [sortingRulesTemp, setSortingRulesTemp] = useState([]);
  const [numColumns, setNumColmuns] = useState(4);
  const [currentScanNum, setcurrentScanNum] = useState(null);
  const [focusedDiv, setFocusedDiv] = useState();
  const [barCodesNotScanned, setBarCodesNotScanned] = useState([]);
  const [sortedShipments, setSortedShipments] = useState([]);
  const [totalSorted, setTotalSorted] = useState({});
  const hubData = useSelector(
    (state) => state.masterReducer.getHubListReducer,
    shallowEqual
  );

  const { result: hubResult } = hubData;
  useEffect(() => {
    dispatch(getHubList());
  }, []);

  useEffect(() => {
    if (currentScanNum) {
      let tempSort = sortShipment;
      let findSort = tempSort.find((e) =>
        e.barcodeAndStatusList.some((item) => item.barcode == currentScanNum)
      )?.cageNumber;
      setFocusedDiv(findSort);
      let findIndex = tempSort.findIndex((e) =>
        e.barcodeAndStatusList.some((item) => item.barcode == currentScanNum)
      );
      if (findIndex > 0) {
        let index = tempSort[findIndex].barcodeAndStatusList.findIndex(
          (e) => e.barcode == currentScanNum
        );
        tempSort[findIndex].barcodeAndStatusList[index].status = "SORTED";
        tempSort[findIndex].barcodeAndStatusList = tempSort[
          findIndex
        ].barcodeAndStatusList.sort(
          (a, b) => a.status.charCodeAt(0) - b.status.charCodeAt(0)
        );
        setSortShipment([...tempSort]);
      }
      if (findSort) {
        setSortedShipments([
          ...sortedShipments,
          { barcode: currentScanNum, cageNumber: findSort },
        ]);
        document.getElementById(findSort).focus();
        document.getElementById(findSort).classList.add("focused-div");
        document.getElementById(findSort).scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
      postScannedBarcode([{ barcode: currentScanNum, cageNumber: findSort }]);
    }
  }, [currentScanNum]);

  useEffect(() => {
    if (hubResult) {
      let premise = hubResult.find(
        (e) => e.premiseId == premiseId.split(" ")[1]
      );
      setPremiseName(
        premise?.premiseName
          .split(" ")
          .map((e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase())
          .join(" ")
      );
    }
  }, [hubResult]);

  useEffect(() => {
    initialize();
  }, []);

  useEffect(() => {
    let sortingData = sortShipment;
    let numberOfColumns = numColumns;
    let sortingDataTemp = [];
    let numRow = sortingData.length / numberOfColumns;
    let x = numberOfColumns;
    let z = 0;
    for (let i = 0; i < numRow; i++) {
      let temp = [];
      for (let y = z; y < x; y++) {
        if (sortingData[y]) {
          temp.push(sortingData[y]);
        }
      }
      sortingDataTemp.push(temp);
      z = x;
      x += numberOfColumns;
    }
    setSortingRulesTemp([...sortingDataTemp]);
  }, [sortShipment]);

  const initialize = async () => {
    setLoading(true);
    let response = await API.Api(SORT_SHIPMENT).getWithPremiseHeader();
    if (response?.status) {
      setTotalSorted({
        sorted: response?.response?.data?.sorted,
        total: response?.response?.data?.total,
      });
      let sortingData = response?.response?.data?.sortingPlanDtos;
      sortingData?.map((e) => {
        e.barcodeAndStatusList = e.barcodeAndStatusList.sort(
          (a, b) => a.status.charCodeAt(0) - b.status.charCodeAt(0)
        );
      });
      let sortingDataTemp = [];
      let numberOfColumns = response?.response?.data?.numberOfColumns || 4;
      setNumColmuns(numberOfColumns);
      let numRow = sortingData.length / numberOfColumns;
      let x = numberOfColumns;
      let z = 0;
      for (let i = 0; i < numRow; i++) {
        let temp = [];
        for (let y = z; y < x; y++) {
          if (sortingData[y]) {
            temp.push(sortingData[y]);
          }
        }
        sortingDataTemp.push(temp);
        z = x;
        x += numberOfColumns;
      }

      setSortingRulesTemp([...sortingDataTemp]);
      setSortShipment(sortingData);
      setLoading(false);
    } else {
      message.error(response?.response?.data?.message || "Ntework error.");
      setLoading(false);
    }
  };

  const sortingCages = () => {
    let temp = [];
    sortingRulesTemp.map((item) => {
      temp.push(
        <div style={{ display: "flex" }}>
          {item.map((e, i) => {
            return (
              <div
                className="view-cage"
                key={`viewCage${i}`}
                style={{
                  minWidth: "170px",
                  maxWidth: "170px",
                  margin: "0.5rem",
                }}
              >
                <div className="space-between align-center">
                  <div className="align-center">
                    <span className="box-no left-box center">
                      {e.cageNumber}
                    </span>
                    <Tooltip
                      title={e.destinationHubName
                        ?.split(" ")
                        .map(
                          (e) =>
                            e.charAt(0).toUpperCase() + e.slice(1).toLowerCase()
                        )
                        .join(" ")}
                    >
                      <div
                        className="fw-500 ml-1 d-hub"
                        style={{ maxWidth: "100px", minWidth: "100px" }}
                      >
                        {e.destinationHubName
                          ?.split(" ")
                          .map(
                            (e) =>
                              e.charAt(0).toUpperCase() +
                              e.slice(1).toLowerCase()
                          )
                          .join(" ")}
                      </div>
                    </Tooltip>
                  </div>
                </div>
                <div
                  className="cage-container p-05"
                  style={{ background: "#EAF1FD", height: "110px" }}
                  id={e.cageNumber}
                >
                  <Row>
                    <Col span={20}>
                      <div className="shipment-show-div">
                        {e?.barcodeAndStatusList?.map((item, i) => {
                          if (i < 5) {
                            return (
                              <span
                                style={{ fontSize: "12px" }}
                                key={`shipment${i}`}
                                className="align-center"
                              >
                                {item.barcode} &nbsp;
                                {item.status == "SORTED" && <Scan_check />}
                                {i == 4 && e?.barcodes?.length > 5
                                  ? "..."
                                  : e?.barcodes?.length > 1 && ","}
                                &nbsp;
                              </span>
                            );
                          }
                        })}
                      </div>
                    </Col>
                    <Col span={4}>
                      <span
                        className="count-circle center pointer"
                        style={{ borderRadius: "2px" }}
                        onClick={() =>
                          showBoxModal(
                            e.cageNumber,
                            e.barcodeAndStatusList,
                            "barcode"
                          )
                        }
                      >
                        {e.barcodeAndStatusList?.length}
                      </span>
                    </Col>
                  </Row>
                </div>
                {/* </div> */}
              </div>
            );
          })}
        </div>
      );
    });
    return temp;
  };

  const showBoxModal = (cageNo, list, type) => {
    let listTemp = [];
    if (type == "hub") {
      list.map((e) => {
        listTemp.push({
          barcode: e.hubName
            .split(" ")
            .map((e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase())
            .join(" "),
          status: "",
        });
      });
    } else {
      listTemp = list;
    }
    setModalContent({
      cageNo: `Box ${cageNo} details`,
      list: listTemp,
      show: true,
    });
  };

  const postScannedBarcode = async (sortedShipments) => {
    // eslint-disable-next-line no-unused-vars
    let response = await API.Api(
      CHANGE_SORT_SHIPMENT_STATUS
    ).postWithPrmiseHeader(sortedShipments);
    if (response?.status) {
      setSortedShipments([]);
      setTotalSorted({ ...totalSorted, sorted: totalSorted.sorted + 1 });
    } else {
      message.error(
        response?.response?.data?.message || "shipment already sorted"
      );
    }
  };

  //--Barcode Scanner--//
  let barcode = "";
  let interval;
  const handleKeyDown = (event) => {
    if (interval) clearInterval(interval);
    if (event.code == "Enter") {
      if (barcode) handleBarcode(barcode);
      barcode = "";
      return;
    }
    if (event.key != "Shift") barcode += event.key;
    interval = setInterval(() => (barcode = ""), 20);
  };

  useEffect(() => {
    window.addEventListener("keydown", handleKeyDown);
    // cleanup this component
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  const handleBarcode = (scanned_barcode) => {
    setcurrentScanNum(parseInt(scanned_barcode));
    return scanned_barcode;
  };

  //--//

  return (
    <div className="p-2-tab">
      <Heading title={"Sort Shipment"} />
      <div className="master-main-container">
        <div className="space-between align-center">
          <p
            className="f-16 fw-700 title-color"
            style={{ padding: "1rem 1rem 0 1rem" }}
          >
            {premiseName}
          </p>
          <div>
            <span
              className="fw-700 mr-1"
              style={{
                background: "#eaf1fd",
                padding: "0.5rem 1rem",
                borderRadius: "5px",
              }}
            >
              <span style={{ color: "#52C41A" }}>{totalSorted?.sorted}</span> /{" "}
              <span style={{ color: "#2E77D0" }}>{totalSorted?.total}</span>
            </span>
            <Input
              className="w-60 mr-1"
              onKeyPress={(e) => {
                if (focusedDiv) {
                  document
                    .getElementById(focusedDiv)
                    .classList.remove("focused-div");
                }

                if (e.key == "Enter") {
                  setcurrentScanNum(parseInt(e.target.value));
                }
              }}
            />
          </div>
        </div>

        <hr className="divider" />
        <Spin spinning={loading}>
          <Row className="sort-class">
            <div className="p-1">{sortingCages()}</div>
          </Row>
        </Spin>
        <Modal
          title={modalContent?.cageNo}
          open={modalContent?.show}
          onCancel={() => setModalContent({})}
          width={600}
          footer={null}
          className="hub-show-modal"
          destroyOnClose
        >
          <Row gutter={15} className="mb-1">
            <Col span={24}>
              <Input
                className="w-30 mr-1"
                onKeyPress={(e) => {
                  if (focusedDiv) {
                    document
                      .getElementById(focusedDiv)
                      .classList.remove("focused-div");
                  }

                  if (e.key == "Enter") {
                    setcurrentScanNum(parseInt(e.target.value));
                  }
                }}
              />
            </Col>
            {modalContent?.list?.length > 0 ? (
              modalContent?.list?.map((e) => {
                return (
                  <Col
                    xs={24}
                    sm={24}
                    md={12}
                    lg={12}
                    xl={12}
                    key={e.value}
                    className="mt-1"
                  >
                    <div className="space-between p-05 modal-hub">
                      <span>{e?.barcode}</span>
                      <span>{e?.status == "SORTED" && <Scan_check />} </span>
                    </div>
                  </Col>
                );
              })
            ) : (
              <Col span={24}>
                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
              </Col>
            )}
          </Row>
        </Modal>
        <Modal
          title="Not sorted barcodes"
          open={barCodesNotScanned.length > 0}
          onCancel={() => setBarCodesNotScanned([])}
          width={700}
          footer={null}
          destroyOnClose
        >
          <>
            <p className="text-center fw-500">
              Below shipments are not sorted. Do you want to proceed for bagging
              ?{" "}
            </p>
            <div className="p-05 center modal-hub">
              <div style={{ width: "500px" }}>
                {barCodesNotScanned.map((e) => {
                  return e.map((item, i) => {
                    return (
                      <span style={{ color: "#e16a3c" }} key={`item${i}`}>
                        {item.barcode}{" "}
                        <span style={{ color: "#000", fontWeight: "500" }}>
                          {i < e.length - 1 || i == 0 ? "," : ""}
                        </span>{" "}
                      </span>
                    );
                  });
                })}
              </div>
            </div>
            <div className="mt-1">
              <hr className="divider" />
              <div className="d-flex flex-end p-1">
                <Button
                  className="cancel-btn ml-1"
                  onClick={() => setBarCodesNotScanned([])}
                >
                  CANCEL
                </Button>
                <Button
                  htmlType="submit"
                  className="save-btn ml-1"
                  onClick={() => navigate("/shipment-bagging")}
                >
                  NEXT
                </Button>
              </div>
            </div>
          </>
        </Modal>
        <div>
          <hr className="divider" />
          <div className="d-flex flex-end p-1">
            <Button
              className="save-btn ml-1"
              onClick={() => navigate("/middle-mile")}
            >
              DONE
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ViewSortingMM;
